
import { AuditModel, PanelDashboardModel, PermissionTypeEnum, TenantUserModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { auditsStore } from '@/libs/audits/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { panelDashboardsStore } from '@/libs/panel-dashboards/+state/store';
import PanelDashboardDetailDialog from '@/libs/panel-dashboards/components/PanelDashboardDetailDialog.vue';

@Component({
    components: {
        PanelDashboardDetailDialog,
    },
})
export default class Audits extends Page {
    pageIndex = 1;
    pageSize = 25;
    pagingChanged = false;
    tenantUser: TenantUserModel = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
    PermissionTypeEnum: typeof PermissionTypeEnum = PermissionTypeEnum;
    @Prop() tenantId!: string;
    @Ref() dialog!: PanelDashboardDetailDialog;

    get totalRows(): number {
        const stats = auditsStore.useGetter(CrudGetter.DataStats) as CrudDataStats;
        return stats?.rowCount ?? 0;
    }

    get headers() {
        return [
            { text: this.$i18n.t('panelDashboards.name'), value: 'name', align: 'left', sortable: false },
            { text: this.$i18n.t('panelDashboards.isActive'), value: 'isActive', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false, width: '0px' },
        ];
    }

    get loading(): boolean {
        return panelDashboardsStore.useGetter(CrudGetter.Pending);
    }

    get audits(): AuditModel[] {
        return [...panelDashboardsStore.useGetter(CrudGetter.Data)];
    }

    @Watch('pageIndex')
    @Watch('pageSize')
    paginationChanged() {
        this.saveQuery();
        if (this.pagingChanged) {
            this.pagingChanged = false;
            return;
        }
        this.load();
    }

    mounted() {
        if (this.getQueryInt('pageSize') != null) {
            this.pageSize = this.getQueryInt('pageSize') ?? 25;
        } else {
            if (window.localStorage.ptPageSize && Number(window.localStorage.ptPageSize)) {
                this.pageSize = Number(window.localStorage.ptPageSize);
            }
            this.saveQuery();
        }
        this.load();
    }

    load() {
        panelDashboardsStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getPayload() {
        return createCrudQueryPayload<PanelDashboardModel>({ field: 'name', index: 1, order: 'asc' }, [], {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
        });
    }

    createItemClick() {
        this.dialog.open();
    }

    saveQuery() {
        this.setQuery('pageSize', this.pageSize?.toString());
        window.localStorage.ptPageSize = this.pageSize?.toString();
    }

    openItem(id: string) {
        this.dialog.open(id);
    }
}
